import "./Button.css";

export default function Button({
  variant = "primary",
  size = "md",
  leftIcon,
  rightIcon,
  loading = false,
  disabled = false,
  className,
  children,
  type = "button",
  ...rest
}) {
  const cls = [
    "vs-btn",
    `vs-btn--${variant}`,
    `vs-btn--${size}`,
    loading && "vs-btn--loading",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && (
        <span className="vs-btn__spinner" aria-hidden="true">
          <span className="vs-btn__spinner-ring" />
        </span>
      )}
      {!loading && leftIcon && (
        <span className="vs-btn__icon vs-btn__icon--left" aria-hidden="true">
          {leftIcon}
        </span>
      )}
      <span className="vs-btn__label">{children}</span>
      {!loading && rightIcon && (
        <span className="vs-btn__icon vs-btn__icon--right" aria-hidden="true">
          {rightIcon}
        </span>
      )}
    </button>
  );
}
